import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
`;

const Quote = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-style: italic;
`;

const Author = styled.h4`
  margin-top: 15px;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.primary};
`;

const TestimonialCard = ({ quote, author }) => (
  <Card>
    <Quote>"{quote}"</Quote>
    <Author>- {author}</Author>
  </Card>
);

export default TestimonialCard;
